
(function () {
  function fixParentLinks() {
    var map = {};
    document.querySelectorAll('.menu-item-has-children > a[href], a.mega-menu-columns__heading').forEach(function (a) {
      var label = a.textContent.trim().toUpperCase();
      var href = a.getAttribute('href');
      if (label && href && !map[label]) map[label] = href;
    });

    document.querySelectorAll('#mobile-menu details > summary').forEach(function (summary) {
      if (summary.dataset.parentLinkFixed) return;
      var details = summary.parentElement;
      var firstNode = summary.childNodes[0];
      var label = (firstNode && firstNode.nodeType === 3) ? firstNode.textContent.trim() : summary.textContent.trim();
      if (!label) return;
      var href = map[label.toUpperCase()];
      if (!href) return;

      var icon = summary.querySelector('span');
      summary.innerHTML = '';
      var link = document.createElement('a');
      link.href = href;
      link.textContent = label;
      link.className = 'parent-link-direct';
      summary.appendChild(link);
      if (icon) summary.appendChild(icon);
      summary.dataset.parentLinkFixed = 'true';

      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = href;
      });
      if (icon) {
        icon.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          details.open = !details.open;
        });
      }
    });
  }

  // Run immediately, then retry a few times to catch any menu
  // content that wasn't fully rendered yet on the first pass.
  fixParentLinks();
  [300, 800, 1500, 3000].forEach(function (delay) {
    setTimeout(fixParentLinks, delay);
  });

  // Also watch the header for any later changes (e.g. a
  // translation app or another script updating menu content)
  // and re-run — cheap, since already-fixed items are skipped.
  var header = document.querySelector('header') || document.body;
  var observer = new MutationObserver(function () {
    fixParentLinks();
  });
  observer.observe(header, { childList: true, subtree: true });
})();